import * as React from 'react';
import { Gauge } from '@mui/x-charts/Gauge';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import { IGaugePanel } from '../Dashboard.model';

interface GaugePanelProps {
  panel: IGaugePanel;
}

export default function GaugePanel(props: GaugePanelProps) {
  const { panel } = props;
  const { title, subtitle, value } = panel;

  return (
    <>
      <Stack direction="column" alignItems="flex-start" width={'100%'}>
        <Typography variant="body1" fontWeight={800} fontSize={'0.8em'}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" fontSize={'0.6em'}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        width={'100%'}
        height={'100%'}
      >
        <Gauge value={value} />
      </Stack>
    </>
  );
}
